import { round } from "mathjs";

export interface IGetConsumptionPer100LitersInput {
  usedLiters: string;
  literPrice: string;
  travelledDistance: string;
}

export interface IGetConsumptionPer100LitersOutput {
  consumptionPer100Liters: number;
  cost: number;
}

export const getConsumptionPer100Liters = ({
  usedLiters,
  literPrice,
  travelledDistance,
}: IGetConsumptionPer100LitersInput): IGetConsumptionPer100LitersOutput => {
  const usedLitersAsNumber = parseFloat(usedLiters.replace(",", "."));
  const literPriceAsNumber = parseFloat(literPrice.replace(",", "."));
  const travelledDistanceAsNumber = parseFloat(travelledDistance.replace(",", "."));

  return {
    consumptionPer100Liters: round((usedLitersAsNumber * 100) / travelledDistanceAsNumber, 2),
    cost: round(literPriceAsNumber * usedLitersAsNumber, 2),
  };
};
